export default "__VITE_PUBLIC_ASSET__ec5d49cf__"